import utkatasana from "./utkatasana.jpg";
import bhujangasana from "./bhujangasana.jpg";
import parvatasana from "./parvatasana.jpg";
import vrikshasana from "./vrikshasana.jpg";
import virbhadrasana from "./virbhadrasana.jpg";
import trikonasana from "./trikonasana.jpg";
import sarvangasana from "./sarvangasana.jpg";

export const poseImages = {
  Vrikshasana: vrikshasana,
  Bhujangasana: bhujangasana,
  Parvatasana: parvatasana,
  Virbhadrasana: virbhadrasana,
  Utkatasana: utkatasana,
  Trikonasana: trikonasana,
  Sarvangasana: sarvangasana,
};
